import { useMemo, useState } from 'react';

function useUserMemo() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

  const isOn = useMemo(
    () => isOpen && selectedUserId !== null,
    [isOpen, selectedUserId],
  );

  const handleOpen = (userId: number) => {
    setSelectedUserId(userId);
    setIsOpen(true);
  };

  const handleClose = () => {
    setSelectedUserId(null);
    setIsOpen(false);
  };

  return { isOn, handleOpen, handleClose, selectedUserId };
}

export default useUserMemo;
